const destinations = [
  {
    name: "Mexico & Honduras",
    context: "Ark-La-Tex church mission teams deploying annually; business travel from regional logistics employers; border community ties",
    urgency: "Mission teams finalize participant lists 2–4 weeks before departure — first-time applicants need expedited service",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Canada",
    context: "Railroad industry safety and training conferences; logging and timber industry meetings; summer vacation travel",
    urgency: "Railroad training assignments often confirmed 2–3 weeks before departure",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Germany & France",
    context: "TAMUT research faculty exchanges; logistics industry supplier meetings; Texarkana College international programs",
    urgency: "Academic conference invitations often arrive with 3–6 week lead time",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Guatemala & El Salvador",
    context: "Miller County church mission teams serving medical and construction projects; Ark-La-Tex nonprofit partners",
    urgency: "Mission trip participants confirmed 2–3 weeks before deployment — urgent processing is common",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "East Africa",
    context: "Texarkana-based church and humanitarian organizations supporting long-term missions in Kenya and Uganda",
    urgency: "Annual team deployments with participant sign-up closing 3–4 weeks before departure",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "United Kingdom",
    context: "Business travel for Texarkana corporate headquarters; logistics industry European meetings; family heritage travel",
    urgency: "Corporate travel assignments often confirmed on 2–4 week timelines",
    icon: "ri-map-pin-2-line",
  },
];

const stats = [
  { stat: "~110 Mi", label: "from Texarkana to Arkansas Passport Center in Hot Springs — we eliminate that trip" },
  { stat: "~140 Mi", label: "from Texarkana to Little Rock — we cover that too" },
  { stat: "2–4 Wks", label: "typical notice Texarkana railroad and logistics professionals receive for international assignments" },
  { stat: "2–9 Days", label: "our most popular processing speed for Texarkana and Ark-La-Tex travelers" },
];

export default function TexarkanaDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Texarkana Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Ark-La-Tex clients. Understanding local travel behavior helps us anticipate the passport urgencies that arise in Texarkana and the tri-state region.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Arkansas Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Arkansas with the same expedited passport processing and document review expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              {[
                { name: "Little Rock", href: "/little-rock" },
                { name: "Hot Springs", href: "/hot-springs" },
                { name: "Fort Smith", href: "/fort-smith" },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap"
                >
                  {link.name} <i className="ri-arrow-right-line text-xs"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}